// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-container {
    height: 100%;
    max-width: 100vw;
    background: rgb(36, 36, 36);
    background: linear-gradient(90deg, rgba(36, 36, 36, 1) 28%, rgba(45, 45, 45, 1) 66%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#242424", endColorstr="#2d2d2d", GradientType=1);
    padding-bottom: 10px;
    padding-top: 3rem;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.description {
    font-weight: 100;
    font-size: 20px;
    margin: auto;
    padding-bottom: 1.5rem;
    max-width: 25rem;
    text-align: center;
}

.back2top {
    width: 40px;
    border-radius: 40px;
    overflow: hidden;
    z-index: 999;
    display: none;
    cursor: pointer;
    transform: rotate(270deg);
    position: fixed;
    bottom: 50px;
    right: 5vw;
    background-color: rgb(191, 206, 226);
    color: #555;
    text-align: center;
    font-size: 30px;
    text-decoration: none;
}

.back2top:hover {
    background-color: lightblue;
    color: #000;
    text-decoration: none;
}

.project-item {
    align-items: center;
    justify-items: center;
    height: 80vh;
    width: 100vw;
    display: grid;
    grid-template-columns: 50% 50%;
    text-align: center;
    color: white;
}

.project-item .big {
    margin-bottom: 1.5rem;
    max-height: 70vh;
    max-width: 40vw;
    box-shadow: 10px 10px 5px rgba(0, 0, 0, 0.5);
}


.project-item a {
    color: black;
    background-color: #bde0fe;
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 45px;
    padding-right: 45px;
}

.project-item a:hover {
    text-decoration: none;
    color: white;
}

.hvr-rectangle-out {
    display: inline-block;
    vertical-align: middle;
    transform: perspective(1px) translateZ(0);
    box-shadow: 0 0 1px rgba(0, 0, 0, 0);
    position: relative;
    background: #e1e1e1;
    transition-property: color;
    transition-duration: 0.3s;
}

.hvr-rectangle-out:before {
    content: "";
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #2098D1;
    transform: scale(0);
    transition-property: transform;
    transition-duration: 0.3s;
    transition-timing-function: ease-out;
}

.hvr-rectangle-out:hover,
.hvr-rectangle-out:focus,
.hvr-rectangle-out:active {
    color: white;
}

.hvr-rectangle-out:hover:before,
.hvr-rectangle-out:focus:before,
.hvr-rectangle-out:active:before {
    transform: scale(1);
}

.info {
    margin-top: 2em;
    text-align: center;
    color: rgba(255, 255, 255, 0.5);
    font-style: italic;
}

@media screen and (max-width: 850px) {
    .project-container {
        flex-direction: column;
    }

    .project-item {
        height: 65vh;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .project-item .big {
        max-height: 40vh;
        max-width: 80vw;
        box-shadow: 10px 10px 5px rgba(0, 0, 0, 0.5);
    }

    .project-content {
        margin-top: 10px;
    }
}`, "",{"version":3,"sources":["webpack://./src/css/projects.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,gBAAgB;IAChB,2BAA2B;IAG3B,oFAAoF;IACpF,kHAAkH;IAClH,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,eAAe;IAKf,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,UAAU;IACV,oCAAoC;IACpC,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;IAC3B,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,4CAA4C;AAChD;;;AAGA;IACI,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IAEtB,yCAAyC;IACzC,oCAAoC;IACpC,kBAAkB;IAClB,mBAAmB;IAEnB,0BAA0B;IAE1B,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,mBAAmB;IAEnB,mBAAmB;IAEnB,8BAA8B;IAE9B,yBAAyB;IAEzB,oCAAoC;AACxC;;AAEA;;;IAGI,YAAY;AAChB;;AAEA;;;IAII,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,4CAA4C;IAChD;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".project-container {\r\n    height: 100%;\r\n    max-width: 100vw;\r\n    background: rgb(36, 36, 36);\r\n    background: -moz-linear-gradient(90deg, rgba(36, 36, 36, 1) 28%, rgba(45, 45, 45, 1) 66%);\r\n    background: -webkit-linear-gradient(90deg, rgba(36, 36, 36, 1) 28%, rgba(45, 45, 45, 1) 66%);\r\n    background: linear-gradient(90deg, rgba(36, 36, 36, 1) 28%, rgba(45, 45, 45, 1) 66%);\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#242424\", endColorstr=\"#2d2d2d\", GradientType=1);\r\n    padding-bottom: 10px;\r\n    padding-top: 3rem;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n    justify-content: center;\r\n    overflow: hidden;\r\n}\r\n\r\n.description {\r\n    font-weight: 100;\r\n    font-size: 20px;\r\n    margin: auto;\r\n    padding-bottom: 1.5rem;\r\n    max-width: 25rem;\r\n    text-align: center;\r\n}\r\n\r\n.back2top {\r\n    width: 40px;\r\n    border-radius: 40px;\r\n    overflow: hidden;\r\n    z-index: 999;\r\n    display: none;\r\n    cursor: pointer;\r\n    -moz-transform: rotate(270deg);\r\n    -webkit-transform: rotate(270deg);\r\n    -o-transform: rotate(270deg);\r\n    -ms-transform: rotate(270deg);\r\n    transform: rotate(270deg);\r\n    position: fixed;\r\n    bottom: 50px;\r\n    right: 5vw;\r\n    background-color: rgb(191, 206, 226);\r\n    color: #555;\r\n    text-align: center;\r\n    font-size: 30px;\r\n    text-decoration: none;\r\n}\r\n\r\n.back2top:hover {\r\n    background-color: lightblue;\r\n    color: #000;\r\n    text-decoration: none;\r\n}\r\n\r\n.project-item {\r\n    align-items: center;\r\n    justify-items: center;\r\n    height: 80vh;\r\n    width: 100vw;\r\n    display: grid;\r\n    grid-template-columns: 50% 50%;\r\n    text-align: center;\r\n    color: white;\r\n}\r\n\r\n.project-item .big {\r\n    margin-bottom: 1.5rem;\r\n    max-height: 70vh;\r\n    max-width: 40vw;\r\n    box-shadow: 10px 10px 5px rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n\r\n.project-item a {\r\n    color: black;\r\n    background-color: #bde0fe;\r\n    padding-top: 5px;\r\n    padding-bottom: 5px;\r\n    padding-left: 45px;\r\n    padding-right: 45px;\r\n}\r\n\r\n.project-item a:hover {\r\n    text-decoration: none;\r\n    color: white;\r\n}\r\n\r\n.hvr-rectangle-out {\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n    -webkit-transform: perspective(1px) translateZ(0);\r\n    transform: perspective(1px) translateZ(0);\r\n    box-shadow: 0 0 1px rgba(0, 0, 0, 0);\r\n    position: relative;\r\n    background: #e1e1e1;\r\n    -webkit-transition-property: color;\r\n    transition-property: color;\r\n    -webkit-transition-duration: 0.3s;\r\n    transition-duration: 0.3s;\r\n}\r\n\r\n.hvr-rectangle-out:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    z-index: -1;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background: #2098D1;\r\n    -webkit-transform: scale(0);\r\n    transform: scale(0);\r\n    -webkit-transition-property: transform;\r\n    transition-property: transform;\r\n    -webkit-transition-duration: 0.3s;\r\n    transition-duration: 0.3s;\r\n    -webkit-transition-timing-function: ease-out;\r\n    transition-timing-function: ease-out;\r\n}\r\n\r\n.hvr-rectangle-out:hover,\r\n.hvr-rectangle-out:focus,\r\n.hvr-rectangle-out:active {\r\n    color: white;\r\n}\r\n\r\n.hvr-rectangle-out:hover:before,\r\n.hvr-rectangle-out:focus:before,\r\n.hvr-rectangle-out:active:before {\r\n    -webkit-transform: scale(1);\r\n    transform: scale(1);\r\n}\r\n\r\n.info {\r\n    margin-top: 2em;\r\n    text-align: center;\r\n    color: rgba(255, 255, 255, 0.5);\r\n    font-style: italic;\r\n}\r\n\r\n@media screen and (max-width: 850px) {\r\n    .project-container {\r\n        flex-direction: column;\r\n    }\r\n\r\n    .project-item {\r\n        height: 65vh;\r\n        display: flex;\r\n        flex-direction: column;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n\r\n    .project-item .big {\r\n        max-height: 40vh;\r\n        max-width: 80vw;\r\n        box-shadow: 10px 10px 5px rgba(0, 0, 0, 0.5);\r\n    }\r\n\r\n    .project-content {\r\n        margin-top: 10px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
